debugConfig.$inject = ['$compileProvider'];

export default function debugConfig($compileProvider) {
    if (process.env.NODE_ENV === 'production') {
        $compileProvider.debugInfoEnabled(false);
    }
}
